var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useState, } from "react";
import { useGlobalState } from "../store/store";
import { isEVMChain, isSolanaChain } from "../utils/chains";
import { useChain } from "./chainContext";
import useWeb3Wallet from "./useWeb3Wallet";
import { useConnection } from "@solana/wallet-adapter-react";
import { useFlexVault } from "./useFlexVault";
export var PendingTransactionsContext = React.createContext({
    pendingTransactions: [],
    transactionsCounter: 0,
});
export var usePendingTransactions = function () {
    var _a = useGlobalState("pendingTransactions"), setPendingTransactions = _a[1];
    var context = useContext(PendingTransactionsContext);
    var addPendingTransaction = useCallback(function (transaction) {
        setPendingTransactions(function (pendingTransactions) { return __spreadArray(__spreadArray([], pendingTransactions), [
            transaction,
        ]); });
    }, [setPendingTransactions]);
    return __assign(__assign({}, context), { addPendingTransaction: addPendingTransaction });
};
export var PendingTransactionsContextProvider = function (_a) {
    var children = _a.children;
    var _b = useGlobalState("pendingTransactions"), pendingTransactions = _b[0], setPendingTransactions = _b[1];
    var _c = useState(0), transactionsCounter = _c[0], setTransactionsCounter = _c[1];
    var ethereumProvider = useWeb3Wallet().ethereumProvider;
    var chain = useChain()[0];
    var update = useFlexVault().update;
    var connection = useConnection().connection;
    /**
     * Keep track with first confirmation
     */
    useEffect(function () {
        pendingTransactions.forEach(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
            var receipt_1, getTransactionStatus_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!transaction.status) return [3 /*break*/, 5];
                        if (!isEVMChain(chain)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ethereumProvider.waitForTransaction(transaction.txhash, 2)];
                    case 1:
                        receipt_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!isSolanaChain(chain)) return [3 /*break*/, 4];
                        return [4 /*yield*/, connection.confirmTransaction(transaction.txhash, "confirmed")];
                    case 3:
                        receipt_1 = _a.sent();
                        _a.label = 4;
                    case 4:
                        getTransactionStatus_1 = function () {
                            if (isEVMChain(chain)) {
                                return receipt_1.status ? "success" : "error";
                            }
                            else if (isSolanaChain(chain)) {
                                return receipt_1.value.err ? "error" : "success";
                            }
                        };
                        setTransactionsCounter(function (counter) { return counter + 1; });
                        setPendingTransactions(function (pendingTransactions) {
                            return pendingTransactions.map(function (_transaction) {
                                if (_transaction.txhash !== transaction.txhash) {
                                    return _transaction;
                                }
                                var pendingTx = __assign(__assign({}, _transaction), { status: getTransactionStatus_1() });
                                return pendingTx;
                            });
                        });
                        if (isSolanaChain(chain))
                            update();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); }, []);
    }, [
        chain,
        connection,
        update,
        pendingTransactions,
        ethereumProvider,
        setPendingTransactions,
    ]);
    return (_jsx(PendingTransactionsContext.Provider, __assign({ value: {
            pendingTransactions: pendingTransactions,
            transactionsCounter: transactionsCounter,
        } }, { children: children }), void 0));
};
//# sourceMappingURL=pendingTransactionsContext.js.map